import { crearTabla } from '@plataforma/ui';

import { listarSuscripcionesBackoffice } from '../api/backoffice.js';
import { exigirSuperAdmin } from '../guardas.js';

import {
  crearBadge,
  crearPaginacion,
  estadoCarga,
  estadoError,
  ESTADOS_SUSCRIPCION,
  fecha,
  moneda,
} from './backoffice-ui.js';
import { montarShell } from './shell.js';

export async function vistaSuscripciones(contenedorRaiz) {
  if (!exigirSuperAdmin()) return;

  const contenido = montarShell(contenedorRaiz, '/suscripciones');
  const estadoVista = { estado: '', pagina: 1 };

  contenido.innerHTML = `
    <div class="pf-backoffice-header">
      <div>
        <h1>Suscripciones</h1>
        <p class="pf-texto-suave">Estado comercial y vigencia por empresa.</p>
      </div>
    </div>
    <form class="pf-tarjeta pf-backoffice-toolbar" id="pf-filtros-suscripciones">
      <div class="pf-campo">
        <label for="pf-suscripcion-estado">Estado</label>
        <select id="pf-suscripcion-estado">
          <option value="">Todas</option>
          <option value="activa">Activa</option>
          <option value="pendiente">Pendiente</option>
          <option value="cancelada">Cancelada</option>
        </select>
      </div>
      <button type="submit" class="pf-boton pf-boton--secundario">Filtrar</button>
    </form>
    <div id="pf-suscripciones-tabla">${estadoCarga()}</div>
  `;

  contenido
    .querySelector('#pf-filtros-suscripciones')
    .addEventListener('submit', async (evento) => {
      evento.preventDefault();
      estadoVista.estado = contenido.querySelector('#pf-suscripcion-estado').value;
      estadoVista.pagina = 1;
      await cargar(contenido, estadoVista);
    });

  await cargar(contenido, estadoVista);
}

async function cargar(contenido, estadoVista) {
  const destino = contenido.querySelector('#pf-suscripciones-tabla');
  destino.innerHTML = estadoCarga();

  const { data, error, count } = await listarSuscripcionesBackoffice(estadoVista);
  if (error) {
    destino.innerHTML = estadoError('No se pudieron cargar las suscripciones.');
    return;
  }

  destino.innerHTML = '';
  destino.appendChild(
    crearTabla({
      filaVacia: 'No hay suscripciones para mostrar.',
      columnas: [
        { titulo: 'Empresa', render: (fila) => fila.empresa?.nombre ?? '—' },
        { titulo: 'Plan', render: (fila) => fila.plan?.nombre ?? '—' },
        { titulo: 'Estado', render: (fila) => crearBadge(ESTADOS_SUSCRIPCION, fila.estado) },
        { titulo: 'Precio', render: (fila) => moneda(fila.plan?.precio_mensual) },
        { titulo: 'Inicio', render: (fila) => fecha(fila.inicia_en) },
        {
          titulo: 'Vencimiento',
          render: (fila) => {
            const fFin = fecha(fila.fin_en);
            const finTotal = fila.empresa?.periodo_activo_fin;
            if (fila.estado === 'activa' && finTotal && finTotal > fila.fin_en) {
              const pendiente = fila.empresa.periodo_servicio?.find(
                (ps) => ps.estado === 'pendiente' && ps.periodo_inicio > fila.fin_en,
              );

              const div = document.createElement('div');
              div.style.lineHeight = '1.4';

              const strTotal = document.createElement('strong');
              strTotal.style.color = 'var(--pf-color-exito)';
              strTotal.textContent = `Total: ${fecha(finTotal)}`;
              div.appendChild(strTotal);

              div.appendChild(document.createElement('br'));

              const spanActual = document.createElement('span');
              spanActual.style.fontSize = '0.75rem';
              spanActual.style.color = 'var(--pf-color-texto-suave)';
              spanActual.textContent = `Actual: ${fFin}`;
              div.appendChild(spanActual);

              if (pendiente) {
                div.appendChild(document.createElement('br'));
                const spanProx = document.createElement('span');
                spanProx.style.fontSize = '0.75rem';
                spanProx.style.color = 'var(--pf-color-texto-suave)';
                spanProx.textContent = `Próxima: ${fecha(pendiente.periodo_inicio)} → ${fecha(pendiente.periodo_fin)}`;
                div.appendChild(spanProx);
              }

              return div;
            }
            return fFin;
          },
        },
        { titulo: 'Trial', render: (fila) => fila.empresa?.trial_estado ?? '—' },
      ],
      filas: data ?? [],
    }),
  );
  destino.appendChild(
    crearPaginacion({
      total: count ?? 0,
      pagina: estadoVista.pagina,
      alCambiar: async (pagina) => {
        estadoVista.pagina = pagina;
        await cargar(contenido, estadoVista);
      },
    }),
  );
}
